import {
  CONTACT_FORM_REQUEST,
  CONTACT_FORM_SUCCESS,
  CONTACT_FORM_FAIL,
  CLEAR_ERRORS,
} from "../constant/contactFormConstants";

export const contactFormReducer = (state = {}, action) => {
  switch (action.type) {
    case CONTACT_FORM_REQUEST:
      return {
        loading: true,
      };
    case CONTACT_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        success: true,
        error:false
      };

    case CONTACT_FORM_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
